/**
 * @file MetricsBar.jsx
 * @description Responsive bar showing key dashboard metrics
 */

import React from 'react';
import { FaClock, FaListUl, FaBox } from 'react-icons/fa';

const MetricCard = ({ title, value, icon: Icon, bgColor }) => (
  <div className={`bg-white shadow rounded-xl p-4 flex items-center gap-4 ${bgColor || ''}`}>
    <div className="bg-blue-100 text-blue-600 p-2 rounded-full">
      <Icon size={20} />
    </div>
    <div>
      <p className="text-sm text-gray-500">{title}</p>
      <p className="text-xl font-bold text-gray-800">{value}</p>
    </div>
  </div>
);

const MetricsBar = ({ totalOrders, avgBumpTime, totalItems }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
      <MetricCard
        title="Total Orders"
        value={totalOrders || 0}
        icon={FaBox}
      />
      <MetricCard
        title="Average Bump Time"
        value={
          avgBumpTime?.[0]?.avg_bump_time_minutes != null
            ? `${avgBumpTime[0].avg_bump_time_minutes} min`
            : 'N/A'
        }
        
        icon={FaClock}
      />
      <MetricCard
        title="Total Items Sold"
        value={totalItems || '—'}
        icon={FaListUl}
      />
    </div>
  );
};

export default MetricsBar;
